/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-04 11:19:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-31 13:16:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Notified/index.tsx
 */
import { message } from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
//import TimeLine from 'src/pages/Order/OrderDetail/ParcelProcess/Components/StatusWithTime';
// import { IFulfillmentStatus } from 'src/types/common/order';
import ModalHoc from 'src/constrains/ModalHOC';
import ClickAndCollectDetail from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/ClickAndCollectDetail';
import Collection, {
  ECollectionType,
} from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/Collection';
import {
  clickCollectByPIN,
  collectWithQRCode,
  notifyCustomer,
  printPackingSlip,
} from 'src/request/order';
import { dateFormat } from 'src/tools/constant';
import { msg } from 'src/tools/message';
import { responseHandler } from 'src/tools/server';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Category from '../Components/Category';

const pinErrorCode = 130104;
const qrErrorCode = 130100;

const Notified = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    data,
    orderNo,
    onUpdate,
    totalPrice,
    pickupPersonName,
    customerPaid,
    buyerName,
    pickupLocation,
    recipientPhoneNo,
    transactionInfo,
    disabled,
    disablePrint,
    collectShop,
  } = props;
  // const [cameraOnLoad,setCameraOnLoad]=React.useState(true)
  const { modalOp } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
  } = modalOp;

  const handleOnCollectViaPin = (uuid, pin) => {
    return clickCollectByPIN({ parcelUuid: uuid, value: pin }).then(
      (data: any) => {
        if (data.errMsg && data.errorCode) {
          return {
            errMsg:
              data.errorCode === pinErrorCode
                ? data.errMsg
                : getI18n(
                    'allOrders.orderDetail.notified_handleOnCollectViaPin_pinerror',
                  ),
            success: false,
          };
        }
        setShowModal(false);
        onUpdate(data);
      },
    );
  };

  const handleOnCollectViaQR = (uuid, pin, cb) => {
    return collectWithQRCode({
      parcelUuid: uuid,
      value: pin,
    }).then((res) => {
      const { success, errorCode, errMsg } = responseHandler(res);
      if (!success && errorCode === qrErrorCode) {
        message.error(
          errMsg ||
            getI18n(
              'allOrders.orderDetail.notified_handleOnCollectViaPin_pinerror',
            ),
          1,
          cb,
        );
      } else {
        handleShowCollectDetail(uuid, ECollectionType.QR, pin);
        return {
          success: false,
          cb,
        };
      }
    });
  };

  const handleOnCollectViaBarcode = (uuid, pin) => {
    return collectWithQRCode({
      parcelUuid: uuid,
      value: pin,
    }).then((res) => {
      const { success, errorCode, errMsg } = responseHandler(res);
      //console.log('res', res);
      if (success) {
        handleShowCollectDetail(uuid, ECollectionType.QR, pin);
        return { success };
      } else {
        if (errorCode === qrErrorCode) {
          return {
            errMsg,
            success,
          };
        }
        return {
          errMsg: getI18n(
            'allOrders.orderDetail.notified_handleOnCollectViaPin_pinerror',
          ),
          success,
        };
      }
    });
  };

  const handleShowCollectDetail = (uuid, type, pin) => {
    setWidth(980);
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allOrders.orderDetail.notified_handleShowCollectDetail_setmodaltitle',
      ),
    );
    setModalContent(
      <ClickAndCollectDetail
        onCancel={() => setShowModal(false)}
        onUpdate={onUpdate}
        pin={pin}
        type={type}
        pickupLocation={pickupLocation}
        uuid={uuid}
        totalPrice={totalPrice}
        customerPaid={customerPaid}
        transactionInfo={transactionInfo}
        recipientPhoneNo={recipientPhoneNo}
        pickupPersonName={pickupPersonName}
        buyerName={buyerName}
      />,
    );
  };
  return (
    <Category
      title={getI18n('allOrders.orderDetail.notified_return_category_title')}
      data={data.map((i) => {
        //console.log('notified', i);
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const packedDate = get(i, 'packedDate', null);
        const pickDate = moment(pickedDate).format(dateFormat);
        const packDate = moment(packedDate).format(dateFormat);
        const parcelNo = get(i, 'parcelNo');
        const uuid = get(i, 'uuid');
        const _lastNotifiedTime = get(i, 'lastNotifiedTime', null);
        const lastNotifiedTime = moment(_lastNotifiedTime).format(dateFormat);
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                'allOrders.orderDetail.notified_return_category_options_pickedtitle',
              ),
              content: pickDate || '-',
            },
            {
              title: getI18n(
                'allOrders.orderDetail.notified_return_category_options_shoptitle',
              ),
              content: collectShop,
            },
            {
              title: getI18n(
                'allOrders.orderDetail.notified_return_category_options_packedtitle',
              ),
              content: packDate,
            },
            {
              title: getI18n(
                'allOrders.orderDetail.notified_return_category_options_statustitle',
              ),
              content: getI18n(
                'allOrders.orderDetail.notified_return_category_title',
              ),
            },
            {
              title: getI18n(
                'allOrders.orderDetail.virtualproduct_returndata_options_judgeTypeGiftcard_notifiedtitle',
              ),
              content: lastNotifiedTime,
            },
          ],
          btns: [
            {
              text: getI18n(
                'allOrders.orderDetail.notified_return_category_btns_QRtext',
              ),
              disabled: disabled,
              onClick: () => {
                setWidth(500);
                setShowModal(true);
                setModalTitle(
                  getI18n(
                    'allOrders.orderDetail.notified_return_category_btns_QRtext',
                  ),
                );
                setModalContent(
                  <Collection
                    onPinSubmit={(pin) => handleOnCollectViaPin(uuid, pin)}
                    type={ECollectionType.QR}
                    onTitleChange={setModalTitle}
                    onQRSubmit={(pin, cb) =>
                      handleOnCollectViaQR(uuid, pin, cb)
                    }
                    onBarcodeSubmit={(barcode) =>
                      handleOnCollectViaBarcode(uuid, barcode)
                    }
                    onCancel={onModalCancel}
                    parcelUuid={uuid}
                    pickupPersonName={pickupPersonName}
                    buyerName={buyerName}
                  />,
                );
              },
            },
            {
              text: getI18n(
                'allOrders.orderDetail.notified_return_category_btns_PINtext',
              ),
              disabled: disabled,
              onClick: () => {
                setWidth(500);
                setShowModal(true);
                setModalTitle(
                  getI18n(
                    'allOrders.orderDetail.notified_return_category_btns_PINtext',
                  ),
                );
                setModalContent(
                  <Collection
                    onPinSubmit={(pin) => handleOnCollectViaPin(uuid, pin)}
                    type={ECollectionType.Pin}
                    onTitleChange={setModalTitle}
                    parcelUuid={uuid}
                    onCancel={onModalCancel}
                    pickupPersonName={pickupPersonName}
                    buyerName={buyerName}
                  />,
                );
              },
            },
          ],
          ...(!disabled && {
            dropOptions: [
              {
                label: getI18n(
                  'allOrders.orderDetail.notified_return_category_dropOtions_notifylabel',
                ),
                onClick: () => {
                  notifyCustomer(uuid, i).then((res) => {
                    onUpdate(res);
                    msg.success('Order has been updated');
                  });
                },
              },
              {
                label: getI18n(
                  'allOrders.orderDetail.notified_return_category_dropOtions_sliplabel',
                ),
                disabled: disablePrint,
                onClick: () => printPackingSlip(uuid),
              },
            ],
          }),
        };
      })}
    />
  );
};
export default ModalHoc(Notified, { width: 500 });
